import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { capitalize, loadScriptByURL } from '../../utils'
import { Constants } from '../../theme'
import { SharedMap } from '../../pages'
import { useVehiclesService, useWebSockets } from '../../hooks'
import useUserLocation from '../../hooks/useUserLocation'

const recaptchaKey = '6LcgYzUeAAAAAMzXJ7ddC57PNtA0k-stcLituAZE'
const initialRegion = {
  latitude: 4.3641759,
  longitude: -73.3833968,
  latitudeDelta: 1,
  longitudeDelta: 1,
}
const { MAP_STREET_ZOOM, MAP_BUILDINGS_TILT } = Constants

function SharedMapContainer() {
  const { generateHeaderSocket, getVehicleInformation } = useVehiclesService()
  const { useSocket, position } = useWebSockets()
  const { userLocation, error: locationError } = useUserLocation()
  const [vehicle, setVehicle] = useState({})
  const [authorization, setAuthorization] = useState(null)
  const [openAlert, setOpenAlert] = useState(false)
  const focusedOnVehicle = useRef(false)
  const [view, setView] = useState({
    detail: false,
    clinic: null,
    center: {
      lat: initialRegion?.latitude,
      lng: initialRegion?.longitude,
    },
    zoomLevel: 6.5,
  })
  const navigate = useNavigate()
  const refSearch = window.location.search.slice(1)

  const vehicleInformation = async (token) => {
    const { vehiculo } = await getVehicleInformation(token)
    if (vehiculo) {
      setVehicle(vehiculo)
    }
  }

  const handleSharePosition = async (tokenCaptcha) => {
    const params = {
      captcha: tokenCaptcha,
      url: refSearch,
    }
    const header = await generateHeaderSocket(params)
    if (header) {
      setAuthorization(header)
      vehicleInformation(header)
    } else {
      setOpenAlert(true)
      setTimeout(() => {
        navigate('../')
      }, 10000)
    }
  }

  const generateCaptcha = () => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(recaptchaKey, { action: 'submit' })
        .then((token) => {
          handleSharePosition(token)
        })
    })
  }
  useEffect(() => {
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`,
      () => {}
    )
    setTimeout(() => {
      generateCaptcha()
    }, 1000)
  }, [])

  useEffect(() => {
    const values = Object.values(vehicle)
    if (values.length > 0) {
      useSocket(vehicle, authorization)
    }
  }, [vehicle])

  const onCloseAlert = () => {
    setOpenAlert(false)
    navigate('../')
  }

  const selectedVehicleData = Object.values(position)
  const vehiclePosition = selectedVehicleData[0]
  const vehicleLat = vehiclePosition?.latitude
  const vehicleLng = vehiclePosition?.longitude
  const vehicleLabel = vehicle?.Marca
    ? `${capitalize(vehicle.Marca)} ${vehicle.Modelo || ''}`.trim()
    : ''

  // `follow` dice qué sigue el mapa después: la moto o la ubicación de quien mira.
  const focusOn = (lat, lng, follow) => {
    setView({
      detail: false,
      clinic: null,
      center: { lat, lng },
      zoomLevel: MAP_STREET_ZOOM,
      tilt: MAP_BUILDINGS_TILT,
      follow,
    })
  }

  // Antes la vista se quedaba en todo Colombia: ahora se acerca a la moto la primera vez.
  // Después el mapa la sigue con la animación del marcador (MapGoogle).
  useEffect(() => {
    if (vehicleLat == null || vehicleLng == null || focusedOnVehicle.current) return
    focusedOnVehicle.current = true
    focusOn(vehicleLat, vehicleLng, 'vehicle')
  }, [vehicleLat, vehicleLng])

  const recenterVehicle = vehiclePosition
    ? () => focusOn(vehicleLat, vehicleLng, 'vehicle')
    : null
  const locateUser = userLocation
    ? () => focusOn(userLocation.latitude, userLocation.longitude, 'user')
    : null

  return (
    <SharedMap
      view={view}
      vehicle={vehicle}
      position={position}
      openAlert={openAlert}
      authorization={authorization}
      onCloseAlert={onCloseAlert}
      userLocation={userLocation}
      locationError={userLocation ? null : locationError}
      selectedVehicleData={selectedVehicleData}
      vehicleLabel={vehicleLabel}
      onRecenterVehicle={recenterVehicle}
      onLocateUser={locateUser}
      followVehicleKey={vehiclePosition?.chasis}
    />
  )
}

export default SharedMapContainer
